import React from "react";

export default function ErrorMessage({ message }) {
    return (
        <div>
            <p className="text-red-500 text-sm">{message}</p>
        </div>
    );
}
